
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestbabyformulalawyers",
      function () {
        return require("private-next-pages/bestbabyformulalawyers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestbabyformulalawyers"])
      });
    }
  